import axios from "./axios-handler.service";
const BASE_URL = "/api/Feriados";

export interface Feriado {
  idFeriado: number;
  dataAlteracao: string;
  estadoEntidade: string;
  descricao: string;
  dia: number;
  mes: number;
  ano: number | null;
}

export class FeriadosService {
  static async listarFeriados(ano: number | null): Promise<Feriado[]> {
    const response = await axios.get<Feriado[]>(`${BASE_URL}/ListarPorAno`, {
      params: {
        ano,
      },
    });
    return response.data;
  }

  static async listarAnos(): Promise<number[]> {
    const response = await axios.get<number[]>(BASE_URL + "/ListarAnos");
    return response.data;
  }

  static async obterFeriado(id: number | null): Promise<Feriado> {
    const response = await axios.get<Feriado>(`${BASE_URL}/ObterFeriado`, {
      params: {
        id,
      },
    });
    return response.data;
  }

  static async alterarFeriado(feriado: Feriado): Promise<void> {
    const response = await axios.post(`${BASE_URL}/AlterarFeriado`, feriado);
    return response.data;
  }

  static async excluirFeriado(id: number): Promise<void> {
    await axios.delete(BASE_URL + "/Excluir", {
      params: { id },
    });
  }
}
